import React from 'react'
import { useState, useEffect,useRef} from 'react'
import ScrollContainer from "react-indiana-drag-scroll";
import Paginator from '../../shared/Paginator';
import NoDataFound from '../../shared/NoDataFound';
import { alphaformatDateTime } from "../../utils/dateFormat";
import TableLoader from '../../shared/TableLoader';
import config from "../../config";
import Select from 'react-select';
import Datepicker from 'react-tailwindcss-datepicker';
import Modal from './components/Modal';
const types = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "full_image",
    label: "Full Image",
  },
  {
    value: "full_video",
    label: "Full Video",
  },
  {
      value:"half_video",
      label:"Half Video"
  },
  {
    value: "promoted_image_story",
    label: "Promoted Image Story ",
  },
  {
    value:"promoted_video_story",
    label:"Promoted Video Story"
  }
]
const AssignedAds = ({Designs,setDesigns,loader,setloader,pickDesign,totalassigned,currentPage,setCurrentPage,handlePageChange})=>{
  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [modalContent, setModalContent] = useState(''); 
  const closeModal = () => {
    setShowModal(false);
    setModalContent('');  // Reset modal content on close
  };

  const openModal = (content) => {
    setModalContent(content);
    setShowModal(true);
  };
    return(
      <div>
      <ScrollContainer>
        <table className="table table-bordered">
          <thead>
            <tr className="bg-gray-100">
              {/* <th className="p-2 text-left">Sales Person Details</th> */}
              {/* <th>Ad Creation Date</th> */}
              {/* <th>Brand</th> */}
              <th>Campaign Name</th>
              {/* <th>Start Date</th> */}
              {/* <th>End Date</th> */}
              <th>Ad Type</th>
              <th>Adops</th>
              <th>Assign Time</th>
              <th>Reference</th>
              <th>Action</th>
            </tr>
          </thead>
            {(Designs.length > 0 && !loader) ? (Designs.map((row, idx) => {
              const created_at = alphaformatDateTime(row.created_at);
              const start_date = alphaformatDateTime(row.creative_start_date);
              const end_date = alphaformatDateTime(row.creative_end_date);
              const assign_time = alphaformatDateTime(row.assigndate);

              return (
              <tbody>
                <tr key={idx} className="border-t">
                  {/* <td className="p-2">
                    <div className="flex items-center gap-1">
                      <sl-icon name="person" />
                      <span>{row.sales_person.sales_person_name}</span>
                    </div>
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <sl-icon name="telephone" />
                      <span>{row.sales_person.mobile}</span>
                    </div>
                  </td> */}
                  {/* <td>
                    <div className='font-bold'>{created_at.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{created_at.timeStr}</div>
                  </td> 
                  <td>{row.brand_name}</td> */}
                  <td>{row.creative_name}</td>
                  {/* <td className="p-2">
                    <div className='font-bold'>{start_date.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{start_date.timeStr}</div>
                  </td> */}
                  {/* <td className="p-2">
                    <div className='font-bold'>{end_date.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{end_date.timeStr}</div>
                  </td> */}
                  <td>{row.ad_creative_sub_type}</td>
                  <td>{row.cst_name}</td>
                  <td>
                    <div className='font-bold'>{assign_time.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{assign_time.timeStr}</div>
                  </td>
                  <td>
                    <button className="bg-blue-600 text-white px-3 py-1 rounded"
                      onClick={() => openModal(JSON.parse(row.content_rough_description))}>
                      ShowRoughDiscription
                    </button>
                  </td>
                  <td>
                    <button className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 transition-colors"
                      onClick={() => {
                        pickDesign(row.content_id,row.creative_id);
                      }}>
                      Pick Ad
                    </button>
                  </td>
                </tr></tbody>
              )
            })) : (!Designs.length > 0 && !loader ) ? (<NoDataFound colspan="10" />)
          : (<TableLoader colspan="10"/>)}
        </table>
      </ScrollContainer>
      <Modal show={showModal} onClose={closeModal} content={modalContent} />
      <div className="flex justify-end">
        {Math.ceil(totalassigned / config.PER_PAGE)  > 1 && (
          <Paginator
            pageCount={Math.ceil(totalassigned / config.PER_PAGE)}
            handlePageClick={handlePageChange}
            forcePage={currentPage}
          />)
        }
      </div>
      </div>
    )
}
export default AssignedAds;